var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 14,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.986 12.423c0-.838-.068-1.45-.216-2.084h-9.573v3.784h5.62c-.114.94-.726 2.356-2.085 3.308l-.02.127 3.028 2.345.21.02c1.925-1.778 3.036-4.395 3.036-7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.197 22.394c2.753 0 5.064-.907 6.752-2.47l-3.217-2.493c-.861.6-2.017 1.02-3.535 1.02-2.697 0-4.985-1.779-5.801-4.238l-.12.01L3.13 16.66l-.041.114a10.19 10.19 0 0 0 9.109 5.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.396 14.213a6.3 6.3 0 0 1-.34-2.016c0-.703.125-1.382.329-2.017l-.006-.135L3.192 7.57l-.104.05A10.2 10.2 0 0 0 2 12.197c0 1.643.397 3.195 1.088 4.577l3.308-2.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.197 5.943c1.914 0 3.206.827 3.943 1.518l2.877-2.81C17.25 3.008 14.95 2 12.197 2a10.19 10.19 0 0 0-9.11 5.62l3.298 2.56c.827-2.458 3.115-4.237 5.812-4.237"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginGoogle);
export default __webpack_public_path__ + "static/media/login-google.db63d034ee3c7ac186a454fb01e1b5b5.svg";
export { ForwardRef as ReactComponent };